export const GET_ARCADES = 'arcades/GET_ARCADES';
export const GET_SCHOOL_ARCADES = 'arcades/GET_SCHOOL_ARCADES';
export const UPDATE_ARCADE_BY_ID = 'arcades/UPDATE_ARCADE_BY_ID';
export const REMOVE_ARCADE_BY_ID = 'arcades/REMOVE_ARCADE_BY_ID';
